// extracted by mini-css-extract-plugin
export var container = "styles-module--container--2QxrU";
export var video = "styles-module--video--2DRu_";